import { FC } from "react";
import { IncreaseOfShareCapitalForm } from "./increaseOfShareCapitalDomain";
import { Box, VBox } from "../../components-v2/Box";
import { observer } from "mobx-react";
import { Checkbox } from "../../components-v2/Checkbox";
import { MTextInput, TextInput } from "../../components-v2/TextInput";
import { NumberField } from "../common/commonComponents";
import { CURRENCY_NOK } from "../../utils/currency";

import { useTranslation } from "../../stores/RootStoreContext";

const ContributionInKind: FC<{ form: IncreaseOfShareCapitalForm }> = observer(({ form }) => {
  const { t } = useTranslation();

  return (
    <>
      <VBox gap={"md"}>
        <div className={"text-lg"}>
          <b>{t("subscriber.contributionInKind")}</b>
        </div>
        <div className={"text-sm"}>{t("subscriber.contributionInKind.info")}</div>
        {form.activeSubscribers.map((subscriber, index) => {
          return (
            <VBox key={subscriber.shareholderId}>
              <Checkbox
                checked={subscriber.hasContributionInKind}
                onChange={() => form.toggleContributionInKind(index)}
                label={subscriber.nameField.inputValue}
              />
              {subscriber.hasContributionInKind && (
                <VBox marginLeft={"sm"}>
                  <Box gap={"sm"} alignItems={"stretch"}>
                    {subscriber.kindContributionDescriptionField.map((k) => (
                      <TextInput
                        key={k.locale}
                        label={
                          subscriber.kindContributionDescriptionField.length === 1
                            ? t("subscriber.kindContribution.description")
                            : t("subscriber.kindContribution.descriptionInLanguage", {
                                language: k.locale.toLocaleUpperCase(),
                              })
                        }
                        value={k.model.inputValue}
                        disabled={!subscriber.hasContributionInKind}
                        onChange={(e) => k.model.setInputValue(e.target.value)}
                        onBlur={() => k.model.commit()}
                      />
                    ))}
                    <NumberField
                      prefix={CURRENCY_NOK}
                      disabled={!subscriber.hasContributionInKind}
                      field={subscriber.kindContributionValueField}
                      label={t("subscriber.kindContribution.value")}
                    />
                  </Box>
                  <MTextInput label={{ key: "address" }} model={subscriber.address} />
                </VBox>
              )}
            </VBox>
          );
        })}
      </VBox>
      <hr />
    </>
  );
});

export default ContributionInKind;
